/**
 * Часовой пояс устройства — для сервера.
 *
 * Новый спринт наступает по часам человека, а сервер живёт в UTC (3.11.6).
 * Пояс уходит с запросом входа и с каждой синхронизацией; настройки для него
 * нет — это факт об устройстве, а не выбор.
 *
 * Без пояса (старый движок, урезанный `Intl`) сервер ничего не переносит, и
 * это лучше, чем перенос по неверному поясу.
 */
export function deviceTimeZone(): string | undefined {
  try {
    const zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return zone === '' ? undefined : zone;
  } catch {
    return undefined;
  }
}
